module.exports = __webpack_public_path__ + "static/fonts/montserrat-v29-cyrillic_cyrillic-ext_latin_latin-ext-600.a2160ba.woff2";